// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1t9d1","footer":"ModalFilter_footer__11kY8"};